import { FC, useState } from "react";
import { PickerModal } from "./PickerModal";
import { BACKGROUNDS, BG_COLORS, isTransparentBg } from "../data";

/**
 * 选择视频背景弹窗（公共组件）
 * - 预设与我的背景 + 上传按钮 + 格式提示
 * - 3 列背景卡片，选中态黑描边
 */
export const BackgroundPickerModal: FC<{
  value: string;
  onClose: () => void;
  onConfirm: (bg: string) => void;
}> = ({ value, onClose, onConfirm }) => {
  const [picked, setPicked] = useState(value);
  const [uploadTip, setUploadTip] = useState("");

  return (
    <PickerModal
      title="选择视频背景"
      subtitle="选择背景后铺满画面，超出比例的部分会居中裁切。"
      width={880}
      onClose={onClose}
      footerLeft={`已选：${picked}`}
      confirmText="使用此背景"
      confirmDisabled={!picked}
      onConfirm={() => onConfirm(picked)}
    >
      <div className="adh-bpk-head">
        <strong>预设与我的背景</strong>
        <button type="button" className="adh-bpk-upload" onClick={() => setUploadTip("上传背景图功能开发中")}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 5v14M5 12h14" />
          </svg>
          上传背景图
        </button>
      </div>
      <p className="adh-bpk-hint">JPG、PNG、WebP；≤ 10MB</p>
      <div className="adh-bpk-grid">
        {BACKGROUNDS.map((bg) => (
          <button
            key={bg}
            type="button"
            className={picked === bg ? "active" : ""}
            onClick={() => setPicked(bg)}
          >
            <span
              className={`adh-bpk-swatch${isTransparentBg(bg) ? " is-transparent" : ""}`}
              style={{ background: isTransparentBg(bg) ? undefined : BG_COLORS[bg] }}
            />
            <strong>{bg}</strong>
            <small>预设背景</small>
          </button>
        ))}
      </div>
      {uploadTip && <div className="adh-toast" role="status">{uploadTip}</div>}
    </PickerModal>
  );
};
